export default __webpack_public_path__ + "static/media/star.fa5ef825.svg";